import { render, staticRenderFns } from "./property-purchase-price.vue?vue&type=template&id=3cd2dd3c"
import script from "./property-purchase-price.vue?vue&type=script&lang=js"
export * from "./property-purchase-price.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports